import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from '../context/AuthContext';
import Card from '../components/common/Card';
import Button from '../components/common/Button';
import Input from '../components/common/Input';
import toast from 'react-hot-toast';
import PwaInstallPanel from '../components/common/PwaInstallPanel';

const Settings = () => {
  const { user } = useAuth();
  
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  
  const [companySettings, setCompanySettings] = useState({
    name: 'SAHALGUUR SERVICES COMPANY',
    tagline: 'Adeegga Guuritaanka',
    phone: '',
    email: '',
    address: '',
    invoicePrefix: 'REF',
    quotationPrefix: 'QUO'
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const docRef = doc(db, 'settings', 'company');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        setCompanySettings(prev => ({ ...prev, ...docSnap.data() }));
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompanySettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    
    try {
      const docRef = doc(db, 'settings', 'company');
      await setDoc(docRef, {
        ...companySettings,
        updatedAt: new Date(),
        updatedBy: user?.uid
      }, { merge: true });
      
      toast.success('Settings waa la keydiyay!');
    } catch (error) {
      toast.error('Khalad: ' + error.message);
    }
    
    setSaving(false);
  };

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="w-10 h-10 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-500">Maamul settings-ka shirkadda</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Company Information */}
        <Card title="Macluumaadka Shirkadda" icon={<span className="text-xl">🏢</span>}>
          <div className="space-y-4">
            <Input
              label="Magaca Shirkadda"
              name="name"
              value={companySettings.name}
              onChange={handleChange}
            />
            <Input
              label="Slogan/Tagline"
              name="tagline"
              value={companySettings.tagline}
              onChange={handleChange}
            />
            <Input
              label="Telefoon"
              name="phone"
              value={companySettings.phone}
              onChange={handleChange}
              placeholder="061XXXXXXX"
            />
            <Input
              label="Email"
              name="email"
              type="email"
              value={companySettings.email}
              onChange={handleChange}
              placeholder="info@sahalguur.com"
            />
            <Input
              label="Cinwaanka"
              name="address"
              value={companySettings.address}
              onChange={handleChange}
              placeholder="Mogadishu, Somalia"
            />
          </div>
        </Card>

        {/* Reference / invoice numbering */}
        <Card title="Lambarrada Ref (Quotation & Invoice)" icon={<span className="text-xl">📄</span>}>
          <div className="space-y-4">
            <Input
              label="Quotation prefix (Ref)"
              name="quotationPrefix"
              value={companySettings.quotationPrefix || 'QUO'}
              onChange={handleChange}
              placeholder="QUO"
            />
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-sm text-gray-500 mb-2">Tusaale Quotation Ref:</p>
              <p className="font-mono text-lg text-primary-600">
                {(companySettings.quotationPrefix || 'QUO').trim() || 'QUO'}-2026-00001
              </p>
            </div>
            <Input
              label="Invoice prefix (Ref)"
              name="invoicePrefix"
              value={companySettings.invoicePrefix}
              onChange={handleChange}
              placeholder="REF"
            />
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-sm text-gray-500 mb-2">Tusaale Invoice Ref:</p>
              <p className="font-mono text-lg text-primary-600">
                {(companySettings.invoicePrefix || 'REF').trim() || 'REF'}-2026-00001
              </p>
            </div>
            <p className="text-xs text-gray-500">
              Lambarka xiga waa iskii u kordhaa marka quotation cusub ama invoice la ansixiyo (sanad kasta counter cusub).
            </p>
          </div>
        </Card>

        {/* App Info */}
        <Card title="Macluumaadka App-ka" icon={<span className="text-xl">📱</span>}>
          <div className="space-y-3">
            <div className="flex justify-between py-2 border-b">
              <span className="text-gray-500">Version</span>
              <span className="font-medium">1.0.0</span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-gray-500">Platform</span>
              <span className="font-medium">Web PWA</span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-gray-500">Admin Email</span>
              <span className="font-medium">{user?.email}</span>
            </div>
            <div className="flex justify-between py-2">
              <span className="text-gray-500">Database</span>
              <span className="font-medium text-green-600">Connected</span>
            </div>
          </div>
        </Card>

        <Card title="Ku rakib App (PWA)" icon={<span className="text-xl">⬇️</span>}>
          <PwaInstallPanel mode="both" />
        </Card>
      </div>

      {/* Save Button */}
      <div className="flex justify-end">
        <Button onClick={handleSave} loading={saving} size="lg">
          Kaydi Settings
        </Button>
      </div>
    </div>
  );
};

export default Settings;